import styled from "styled-components";
import { doctorBanner, doctorBanner2, doctorBanner3, listItemIcon, logo_svg } from "../constants/images";
import { Colors } from "./colors";
import { ca } from "date-fns/locale";

export const VImage = styled.img<{$width?:string,$height?:string,$blur?:number,$opacity?:number,$borderRadius?:string}>`
    width: ${props => props.$width || '100%'};
    height: ${props => props.$height || 'auto'};
    opacity: ${props => props.$opacity || 1};
    border-radius: ${props => props.$borderRadius || '0'};
   
`;

export const HeroBanner = styled.div<{$background?:string,$height?:number,$backgroundImage?:any,$padding?:string, $alignItems?:string,$backgroundSize?:'no-repeat' | 'contain'} >`
    display: flex;
    width: 100%;
    padding: ${props => props.$padding};
    position: relative;
    background: ${props => props.$background || 'transparent'} url(${props => props.$backgroundImage}) no-repeat;
    background-position: 100% 0%; 
    background-size: ${props => props.$backgroundSize || 'no-repeat'};
    background-repeat: no-repeat;
    height: ${props => props.$height+'vh' || 'auto'};
    z-index: 1;
    min-height: 50vh;
    box-sizing: border-box;
    justify-content: center;
    align-items: ${props => props.$alignItems || 'center'};
    @media (max-width: 767.98px) {
        background: ${props => props.$background || 'transparent'}  no-repeat;
        background-position: 100% 0%; 
        background-size: stretch;
        background-repeat: no-repeat;
        justify-items: center;
        height: ${props => (props.$height ? 1.2* props.$height / 2 + 'vh' : 'auto')};
        min-height: 40vh;
        text-align: center;
        

}

`

export const Col = styled.div<{ flex?:string, $zIndex?:number ,$position?:string,$margin?:string, $backgroundColor?:string,$gap?:number, $width?:string,$maxWidth?:string,$height?:string,$justifyContent?:string,$alignItems?:string,$border?:string,$padding?:string , $borderRadius?:number | string,$color?:string,$alignSelf?:string}>`
    display: flex;
    width: ${props=>props.$width};
    height: ${props=>props.$height};
    position: ${props=>props.$position || 'relative'};
    z-index: ${props=>props.$zIndex || 0};
    background-color: ${props=>props.$backgroundColor || 'transparent'};
    margin: ${props=>props.$margin};
    color: ${props=>props.$color || Colors.blackText};
    border-radius:${props =>typeof props.$borderRadius === 'number' ? `${props.$borderRadius}px` : props.$borderRadius || '0'};
    padding: ${props=>props.$padding};
    border: ${props=>props.$border};
    flex-direction: column;
    justify-content: ${props=>props.$justifyContent || 'center'};
    align-items: ${props=>props.$alignItems || 'center'};
    box-sizing: border-box;
    gap: ${props=>props.$gap || 0}px;
    align-self: ${props=>props.$alignSelf || 'auto'};
    flex: ${props => props.flex || 'initial'}; 
    max-width: ${props => props.$maxWidth !== undefined ? props.$maxWidth: 'none' };
`

export const BoxContainer = styled.div<{$background?:string ,$width?:string}>`

    display: flex;
    width: ${props => props.$width || '100%'};
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${props => props.$background || Colors.whiteBackground};
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    border: 1px solid ${Colors.fieldBorder};

`

export const MainContainer = styled.div<{$isMobile?:boolean}>`
    display: flex;
    gap: 20px;
    padding: ${props => props.$isMobile ? '5px' : '40px'};
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width:${props => props.$isMobile ? '100%' : '80%'};
    `

export const Row = styled.div<{
    $padding?: string;
    $height?: string;
    $backgroundColor?: string;
    $width?: string;
    $justifyContent?: string;
    $alignItems?: string;
    $margin?: string;
    $gap?: number;
    $wrap?: string;
    $flex?: string; // Added dynamic flex property
    $border?:string;
    $borderRadius?:number | string;
  }>`
    display: flex;
    position: relative;
    border: ${props=>props.$border};
    width: ${props => props.$width || '100%'};
    height: ${props => props.$height || 'auto'};
    background-color: ${props => props.$backgroundColor || 'transparent'};
    gap: ${props => props.$gap || 0}px;
    margin: ${props => props.$margin || '0'};
    padding: ${props => props.$padding || '0'};
    justify-content: ${props => props.$justifyContent || 'center'};
    align-items: ${props => props.$alignItems || 'center'};
    flex-wrap: ${props => props.$wrap || 'wrap'};
    justify-self: center;
    flex: ${props => props.$flex || 'initial'}; // Dynamically set flex
    border-radius:${props =>typeof props.$borderRadius === 'number' ? `${props.$borderRadius}px` : props.$borderRadius || '0'};
  `;

  
export const Title = styled.h2<{$color?:string,$fontSize?:number,$margin?:string}>`
    color: ${props=>props.$color || Colors.blackText};
    font-weight: 700;
    margin: ${props=>props.$margin};
    font-size: ${props=>props.$fontSize || 36}px;
    @media (max-width: 767.98px) {
 
        font-size: ${props=>props.$fontSize?props.$fontSize*0.7:18}px;
 
    }
`

export const SubTitle = styled.h3<{$color?:string,$fontSize?:string,$margin?:string}>`
    color: ${props=>props.$color || Colors.blackText};
    font-size: ${props=>props.$fontSize || '24px'};
    font-weight: 700;
    margin: ${props=>props.$margin};
`
export const Text = styled.p<{$color?:string,$fontSize?:string,$margin?:string,$fontWeight?:number}>`
    color: ${props=>props.$color || Colors.blackText};
    font-size: ${props=>props.$fontSize || '16px'};
    font-weight: ${props=>props.$fontWeight || 400};
    margin: ${props=>props.$margin};
    
`

export const IconArea = styled.div<{$backgroundColor?:any,top?:number}>`
    display: flex;
    position: absolute;
    top: ${props=>props.top || 0}px;
    border: none;
    width: 70px;
    height: 70px;
    align-items: center;
    justify-content: center;
    background-color: ${props=>props.$backgroundColor || 'transparent'};
    background-position: center;
    border-radius: 0;
    -webkit-transition: 0.7s;
    -ms-transition: 0.7s;
    transition: 0.7s;
    margin: 0 auto;
    transform: rotate(45deg);
    overflow: hidden;
`
export const IconAreaImg = styled.img<{$width?: string, $height?: string}>`
    width: ${props => props.$width || '100%'};
    transform: rotate(-45deg);
    transition: transform 0.5s ease-in-out;

    &:hover {
        transform: rotate(-45deg) rotateY(360deg);
    }
`

export const List = styled.ul<{$color?:string,$fontSize?:string,$margin?:string}>`
    color: ${props=>props.$color || Colors.blackText};
    font-size: ${props=>props.$fontSize || '16px'};
    display: flex;
    flex-direction: column;
    font-weight: 400;
    gap: 15px;
    margin: ${props=>props.$margin || '0 15px 0 0'};
`   

export const ListItem = styled.li<{$color?: string; $fontSize?: number; $margin?: string}>`
    color: ${props => props.$color || Colors.blackText};
    font-size: ${props => props.$fontSize || 16}px;
    font-weight: 400;
    margin: ${props => props.$margin};
    display: flex;
    align-items: center;
    padding-left: 15px; /* Adjust left padding for more space */

    &::before {
    content: "";
    display: inline-block;
    flex-shrink: 0;
    width: ${props => (props.$fontSize ? props.$fontSize + 10 : 24)}px;
    height: ${props => (props.$fontSize ? props.$fontSize + 10 : 24)}px;
    background-image: url(${listItemIcon});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    margin-left: 12px;
}
`

export const DotListItem = styled.li<{$color?: string; $fontSize?: number; $margin?: string}>`
    color: ${props => props.$color || Colors.blackText};
    font-size: ${props => props.$fontSize || 16}px;
    font-weight: 400;
    margin: ${props => props.$margin};
    display: flex;
    align-items: center;
    padding-left: 5px; /* Adjust left padding for more space */

    &::before {
    content: "";
    display: inline-block;
    flex-shrink: 0;
    width: 6px;
    height: 6px;
    background-color: ${Colors.primary}; /* Changed to blue dot */
    border-radius: 50%; /* Make it a circle */
    margin-left: 6px;
}
`

export const VerticalSeparator = styled.div<{$height?: string, $color?: string, $width?: string, $margin?: string}>`
    height: ${props => props.$width || '1px'};
    width: ${props => props.$height || '100%'};
    background-color: ${props => props.$color || Colors.fieldBorder};
    margin: ${props => props.$margin || '0'};
`

export const TabButtons = styled.ul`
    display: flex;
    border-radius:50px;
    background-color:'#fafafa';
    border:0;
    
`

export const TabButtonsItem = styled.li<{ $isActive?: boolean }>`
    border-radius: 20px;
    padding: 10px 10px;
    background-color: ${props => props.$isActive ? '#0E82FD' : '#FFF'};
    border-color: ${props => props.$isActive ? '#0E82FD' : '#DDD'};
    color: ${props => props.$isActive ? '#FFF' : '#000'};
`


export const Toggle = styled.div<{$isActive?: boolean}>`
    width: 50px;
    height: 25px;
    background-color: ${props => props.$isActive ? Colors.primary : Colors.fieldBorder};
    border-radius: 25px;
    position: relative;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &::after {
        content: "";
        position: absolute;
        top: 2px;
        left: ${props => props.$isActive ? '26px' : '2px'};
        width: 21px;
        height: 21px;
        background-color: #FFF;
        border-radius: 50%;
        transition: left 0.3s ease;
    }
`;

export const StatusBox = styled.div<{$status?: 'pending' | 'approved' | 'rejected' | 'completed' | 'cancelled',$fontSize?:number}>`
margin: 5px 0px;
    font-size: ${props => props.$fontSize || 14}px;
    padding: 5px 15px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    color: ${props => {
        switch (props.$status) {
            case 'pending':
                return Colors.pending;
            case 'approved':
                return Colors.approved;
            case 'rejected':
                return Colors.error;
            case 'completed':
                return Colors.success;
            case 'cancelled':
                return Colors.canceled;
            default:
                return Colors.blackText;
        }
    }};
    background-color: ${props => {
        switch (props.$status) {
          case 'pending':
            return Colors.pendingBackground;
          case 'approved':
            return Colors.approvedBackground;
          case 'rejected':
            return Colors.errorBackground;
          case 'completed':     
            return Colors.successBackground;
            case 'cancelled':
            return Colors.canceledBackground;
          default:
            return Colors.whiteBackground;
        }
    }};

    &::before {
        content: "";
        display: inline-block;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: currentColor;
        margin-left: 5px;
    }
`;

export const CaseStatusBox = styled.div<{$status?: CaseStatus,$fontSize?:number}>`
margin: 5px 0px;
    font-size: ${props => props.$fontSize || 14}px;
    padding: 5px 15px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    color: ${props => {
        switch (props.$status) {
            case "New":
                return Colors.pending;
            case "Escalated":
                return Colors.approved;
            case "On Hold":
                return Colors.error;
            case "In Progress":
                return Colors.success;
            case "Closed":
                return Colors.canceled;
            default:
                return Colors.blackText;
        }
    }};
    background-color: ${props => {
        switch (props.$status) {
          case 'New':
            return Colors.pendingBackground;
          case 'Escalated':
            return Colors.approvedBackground;
          case 'On Hold':
            return Colors.errorBackground;
          case 'In Progress':     
            return Colors.successBackground;
            case 'Closed':
            return Colors.canceledBackground;
          default:
            return Colors.whiteBackground;
        }
    }};

    &::before {
        content: "";
        display: inline-block;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: currentColor;
        margin-left: 5px;
    }
`;